import MonitorHeartIcon from "@mui/icons-material/MonitorHeart";
import { ClinicalTrialist } from "./components/ClinicalTrialist";

const resource = {
  list: ClinicalTrialist,
  icon: MonitorHeartIcon,
};

export default resource;
